<template>
  <div class="absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
    <div class="py-1" role="none">
      <h3 class="px-4 py-2 text-sm font-semibold text-gray-900">Ärzte</h3>
      <a v-for="practitioner in practitioners" :key="practitioner.uuid" 
         @click="selectPractitioner(practitioner)"
         class="text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900 flex justify-between items-center" role="menuitem" tabindex="-1">
        <span>{{ practitioner.givenName }} {{ practitioner.surname }}</span>
        <span v-if="isSelectedPractitioner(practitioner)" class="text-green-500">✓</span>
      </a>
    </div>
    <div class="py-1" role="none">
      <h3 class="px-4 py-2 text-sm font-semibold text-gray-900">Organisationen</h3>
      <a v-for="organization in organizations" :key="organization.uuid" 
         @click="selectOrganization(organization)"
         class="text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900 flex justify-between items-center" role="menuitem" tabindex="-1">
        <span>{{ organization.name }}</span>
        <span v-if="isSelectedOrganization(organization)" class="text-green-500">✓</span>
      </a>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useDbStore } from '../../stores/dbStore';

export default {
  name: 'ManagementDropdown',
  setup() {
    const dbStore = useDbStore();

    const practitioners = computed(() => dbStore.practitioners);
    const organizations = computed(() => dbStore.organizations);

    const selectPractitioner = (practitioner) => {
      dbStore.setSelectedPractitioner(practitioner.uuid);
    };

    const selectOrganization = (organization) => {
      dbStore.setSelectedOrganization(organization.uuid);
    };

    const isSelectedPractitioner = (practitioner) => {
      return dbStore.selectedPractitioner && dbStore.selectedPractitioner.uuid === practitioner.uuid;
    };

    const isSelectedOrganization = (organization) => {
      return dbStore.selectedOrganization && dbStore.selectedOrganization.uuid === organization.uuid;
    };

    return {
      practitioners,
      organizations,
      selectPractitioner,
      selectOrganization,
      isSelectedPractitioner,
      isSelectedOrganization
    };
  }
}
</script>